import { __exports as CODE128 } from "./index219.js";
import { __require as requireBarcode } from "./index158.js";
import { __require as requireConstants } from "./index196.js";
var hasRequiredCODE128;
function requireCODE128() {
  if (hasRequiredCODE128) return CODE128;
  hasRequiredCODE128 = 1;
  Object.defineProperty(CODE128, "__esModule", {
    value: true
  });
  var _createClass = /* @__PURE__ */ (function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  var _constants = requireConstants();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var CODE128$1 = (function(_Barcode) {
    _inherits(CODE1282, _Barcode);
    function CODE1282(data, options) {
      _classCallCheck(this, CODE1282);
      var _this = _possibleConstructorReturn(this, (CODE1282.__proto__ || Object.getPrototypeOf(CODE1282)).call(this, data.substring(1), options));
      _this.bytes = data.split("").map(function(char) {
        return char.charCodeAt(0);
      });
      return _this;
    }
    _createClass(CODE1282, [{
      key: "valid",
      value: function valid() {
        return /^[\x00-\x7F\xC8-\xD3]+$/.test(this.data);
      }
      // The public encoding function
    }, {
      key: "encode",
      value: function encode() {
        var bytes = this.bytes;
        var startIndex = bytes.shift() - 105;
        var startSet = _constants.SET_BY_CODE[startIndex];
        if (startSet === void 0) {
          throw new RangeError("The encoding does not start with a start character.");
        }
        if (this.shouldEncodeAsEan128() === true) {
          bytes.unshift(_constants.FNC1);
        }
        var encodingResult = CODE1282.next(bytes, 1, startSet);
        return {
          text: this.text === this.data ? this.text.replace(/[^\x20-\x7E]/g, "") : this.text,
          data: (
            // Add the start bits
            CODE1282.getBar(startIndex) + // Add the encoded bits
            encodingResult.result + // Add the checksum
            CODE1282.getBar((encodingResult.checksum + startIndex) % _constants.MODULO) + // Add the end bits
            CODE1282.getBar(_constants.STOP)
          )
        };
      }
      // GS1-128/EAN-128
    }, {
      key: "shouldEncodeAsEan128",
      value: function shouldEncodeAsEan128() {
        var isEAN128 = this.options.ean128 || false;
        if (typeof isEAN128 === "string") {
          isEAN128 = isEAN128.toLowerCase() === "true";
        }
        return isEAN128;
      }
      // Get a bar symbol by index
    }], [{
      key: "getBar",
      value: function getBar(index) {
        return _constants.BARS[index] ? _constants.BARS[index].toString() : "";
      }
      // Correct an index by a set and shift it from the bytes array
    }, {
      key: "correctIndex",
      value: function correctIndex(bytes, set) {
        if (set === _constants.SET_A) {
          var charCode = bytes.shift();
          return charCode < 32 ? charCode + 64 : charCode - 32;
        } else if (set === _constants.SET_B) {
          return bytes.shift() - 32;
        } else {
          return (bytes.shift() - 48) * 10 + bytes.shift() - 48;
        }
      }
    }, {
      key: "next",
      value: function next(bytes, pos, set) {
        if (!bytes.length) {
          return { result: "", checksum: 0 };
        }
        var nextCode = void 0, index = void 0;
        if (bytes[0] >= 200) {
          index = bytes.shift() - 105;
          var nextSet = _constants.SWAP[index];
          if (nextSet !== void 0) {
            nextCode = CODE1282.next(bytes, pos + 1, nextSet);
          } else {
            if ((set === _constants.SET_A || set === _constants.SET_B) && index === _constants.SHIFT) {
              bytes[0] = set === _constants.SET_A ? bytes[0] > 95 ? bytes[0] - 96 : bytes[0] : bytes[0] < 32 ? bytes[0] + 96 : bytes[0];
            }
            nextCode = CODE1282.next(bytes, pos + 1, set);
          }
        } else {
          index = CODE1282.correctIndex(bytes, set);
          nextCode = CODE1282.next(bytes, pos + 1, set);
        }
        var enc = CODE1282.getBar(index);
        var weight = index * pos;
        return {
          result: enc + nextCode.result,
          checksum: weight + nextCode.checksum
        };
      }
    }]);
    return CODE1282;
  })(_Barcode3.default);
  CODE128.default = CODE128$1;
  return CODE128;
}
export {
  requireCODE128 as __require
};
//# sourceMappingURL=index193.js.map
